<template>
  <div class="card red">
    <div class="content">
      <div class="header">
        {{ $t('CHAT_SERVICE_TRIGGER') }}
        <i class="right floated chat icon"></i>
      </div>
      <div class="meta">
        {{ $t('CHAT_SERVICE_TRIGGER_META') }}
      </div>
    </div>

    <div class="primary content">
      <div class="field">
        <typeahead
          :max-items="100"
          :current-item="service.name"
          :items="allChatServices"
          :label-text="$tc('CHAT_SERVICE', 1)"
          :placeholder-text="$tc('CHAT', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('CHAT_SERVICE', 2) })"
          :select-handler="setService"
        >
          <template slot="dropdown" slot-scope="props">
            {{ $t(props.item.name) }}
          </template>
        </typeahead>
      </div>
      <regex-field v-model="trigger.configuration.channel" :labelText="$t('CHAT_CHANNEL')" />
      <regex-field v-model="trigger.configuration.from" :labelText="$t('CHAT_FROM')" />
      <regex-field v-model="trigger.configuration.message" :labelText="$t('CHAT_MESSAGE')" />
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import _ from 'lodash'
import { Typeahead, RegexField } from 'ui'
import { Service, Typenames } from 'services'
import { map } from 'rxjs/operators'
import { ActionTypes } from 'store'
export default {
  name: 'chat-trigger',
  components: {
    Typeahead,
    RegexField
  },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            channel: '',
            from: '',
            message: ''
          }
        }
      }
    }
  },

  data() {
    return {
      service: {}
    }
  },

  computed: {
    allServices() {
      return this.$store.state.service.items
    },
    allChatServices() {
      return _.map(_.filter(this.allServices, s => s.serviceType === 'CHAT'), s => {
        return {
          name: s.name || s.id,
          key: s.id,
          id: s.id,
          value: s.id,
          icon: s.serviceConfiguration.iconType
        }
      })
    }
  },

  methods: {
    setService(s) {
      this.trigger.configuration.serviceId = s.id
    }
  },

  created() {
    Service.readAllServices()
  },

  mounted() {
    if (_.isEmpty(this.service))
      this.service =
        _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
  },

  watch: {
    allServices() {
      if (_.isEmpty(this.service))
        this.service =
          _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
    }
  }
}
</script>
